import { render, staticRenderFns } from "./GameMode.vue?vue&type=template&id=e12c2a3a&scoped=true&"
import script from "./GameMode.vue?vue&type=script&lang=js&"
export * from "./GameMode.vue?vue&type=script&lang=js&"
import style0 from "./GameMode.vue?vue&type=style&index=0&id=e12c2a3a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12c2a3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu})
